<div class="success">
  <div class="check">✓</div>
  <h2>工单已提交</h2>
  <p>已进入售后队列，客服正在处理。</p>
  <div class="ticket-no">{{ ticket.ticket_no }}</div>
  <div class="detail">
    <div class="detail-top">
      <div>
        <h3>{{ problemInfo.name }}</h3>
        <p>
          {{ platformInfo.order.platform_name }} · {{ platformInfo.account }}
        </p>
      </div>
      <span class="pill processing">处理中</span>
    </div>
    <div class="eta-card">
      <div class="eta-icon">↻</div>
      <div class="eta-copy">
        <span>预计处理时间</span><strong>10 分钟内</strong>
      </div>
    </div>
    <div class="timeline">
      <div class="ts pass">已提交</div>
      <div class="ts on">处理中</div>
      <div class="ts">待确认</div>
      <div class="ts">已完成</div>
    </div>
  </div>
  <div
    style="
      display: flex;
      justify-content: center;
      gap: 8px;
      flex-wrap: wrap;
      margin-top: 17px;
    "
  >
    <button class="primary-btn" (click)="checkFormDetail()">
      查看工单详情
    </button>
  </div>
</div>
